export class LocalImages {
    static avatar = 'https://i.imgur.com/PgWf66s.png'
    static avatar_with_laptop = "https://i.imgur.com/ex26LWd.png"
}

export class WebImages {
    static giftIcon = 'https://user-images.githubusercontent.com/6418354/155841091-9bdc3b05-fabd-4e58-a0fd-fe90b08275e4.png'
    static flutterIcon = 'https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg'
}